import PageShell from "./PageShell";
import PillarSection from "@/components/site/PillarSection";
import { IMAGES } from "@/lib/content";

const GALLERY = [
  { src: IMAGES.arrival, label: "The Arrival" },
  { src: IMAGES.concierge, label: "Concierge" },
  { src: IMAGES.welcomeKitchen, label: "Pantry Stocking" },
  { src: IMAGES.interior, label: "Property Preparation" },
];

export default function WelcomePage() {
  return (
    <PageShell testId="page-welcome">
      <PillarSection
        pillarKey="Welcome"
        heroImage={IMAGES.arrival}
        galleryImages={GALLERY}
      />
    </PageShell>
  );
}
